import React, {Component} from 'react'
import { NavLink } from 'react-router-dom'

class Subnav extends Component {
    render() {
        return (
            <div className="c-subnav">
                <div className="o-spacer"></div>
                <div className="c-subnav__inner">
                    <div className="c-subnav__items">
                        <NavLink activeClassName="is-active" to="/community/groups">
                            Groepen
                        </NavLink>
                        <NavLink activeClassName="is-active" to="/community/meetings">
                            Meetings
                        </NavLink>
                    </div>
                </div>
            </div>
        )
    }
}

export default Subnav